module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "landing-page pa-4"
  }, [_c('div', {
    staticClass: "header-container ma-4"
  }, [_c('div', {
    class: {
      'header-content': _vm.$vuetify.breakpoint.width > 1280
    }
  }, [_c('div', {
    staticClass: "logo-and-menu",
    class: {
      'display-flex justify-center align-center': _vm.$vuetify.breakpoint.width <= 1280,
    }
  }, [_c('div', {
    staticClass: "logo-container",
    on: {
      "click": function($event) {
        _vm.tab = null
      }
    }
  }, [_c('router-link', {
    staticClass: "logo-link",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/landing-page/ys_logo_primary-black.svg",
      "aspect-ratio": "1",
      "height": "44",
      "width": "144"
    }
  })])], 1), _vm._v(" "), (_vm.$vuetify.breakpoint.width > 1280) ? _c('div', {
    staticClass: "links-container white--text font-space-grotesk font-weight-700 text-18"
  }, [_vm._l((_vm.tabList), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "menu-item cursor-pointer",
      class: {
        'active-menu': _vm.tab == item.value
      },
      on: {
        "click": function($event) {
          _vm.tab = item.value
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.text) + "\n            ")])
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item cursor-pointer",
    on: {
      "click": function($event) {
        _vm.navigateTo('/login')
      }
    }
  }, [_vm._v("\n              Signin\n            ")])], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
    class: {
      'main-content': _vm.$vuetify.breakpoint.width > 1280
    }
  }, [(!_vm.tab) ? _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-space-around": "",
      "row": "",
      "gap-8": "",
      "main-content-wrapper": ""
    }
  }, [_c('div', {
    staticClass: "blurb-container"
  }, [_c('div', {
    staticClass: "white--text font-space-grotesk font-weight-500",
    class: {
      'text-container': _vm.$vuetify.breakpoint.width > 1280
    }
  }, [_c('span', {
    class: _vm.$vuetify.breakpoint.width <= 1280 ?
      'text-32 text-center display-flex' :
      'text-50'
  }, [_vm._v("\n              Music Streaming\n              "), _c('br'), _vm._v("\n              Evolved\n            ")]), _vm._v(" "), (_vm.$vuetify.breakpoint.width > 1280) ? _c('div', {
    staticClass: "app-icons-container"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "row": "",
      "mt-4": "",
      "pt-4": ""
    }
  }, [_c('div', {
    staticClass: "app-icon-container"
  }, [_c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": "/static/images/landing-page/apple-store.svg",
      "aspect-ratio": "1",
      "height": "80",
      "width": "220"
    },
    on: {
      "click": function($event) {
        _vm.openQrCode(_vm.qrCodeTypeList.IOS)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "app-icon-container"
  }, [_c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": "/static/images/landing-page/google-play.svg",
      "aspect-ratio": "1",
      "height": "80",
      "width": "220"
    },
    on: {
      "click": function($event) {
        _vm.openQrCode(_vm.qrCodeTypeList.ANDROID)
      }
    }
  })])])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/landing-page/ys-landing-ios.svg",
      "aspect-ratio": "1",
      "height": "677"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.tab == 'go_premium') ? _c('UpgradePlan', {
    staticClass: "py-5",
    attrs: {
      "category-plan": _vm.categoryPlan
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tab == 'revenue_calculator') ? _c('RevenueCalculator', {
    staticClass: "py-5 w-100"
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.$vuetify.breakpoint.width <= 1280) ? _c('div', {
    class: {
      'bg-white sp-text': _vm.tab == null,
    }
  }, [(_vm.tab == null) ? _c('div', {
    class: [
      'display-flex justify-space-between align-center btn-wrapper',
      {
        'scrolled': _vm.isScrolled
      }
    ]
  }, [_c('button', {
    staticClass: "btn-try-calculator",
    on: {
      "click": _vm.goToCalculator
    }
  }, [_vm._v("\n        Estimator\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-sign-up",
    on: {
      "click": _vm.redirectToAppStore
    }
  }, [_vm._v("\n        Sign up\n      ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.width > 1280) ? _c('FooterLandingPage') : _vm._e(), _vm._v(" "), _c('QrCode', {
    ref: "qrCode"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2790b15c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/landing-new/index.vue
// module id = 1654
// module chunks = 180